if ('onerror' in window) {
    window.onerror = function(message, file, line) {
        if (SA.Env.isTestServer) {
            alert(
                'An unexpected error has occurred. You may need to refresh your browser to continue.\n' +
                '\n' +
                'Error Message:\n' +
                '* ' + message + '\n' +
                '\n' +
                'File:\n' +
                '* ' + file + ':' + line + '\n' +
                '\n' +
                'Browser:\n' +
                '* ' + navigator.userAgent
            );
        }
    };
}